import { Flex } from 'foundations-components/components/Flex';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import formatName from 'I18n/utils/formatName';
import { View } from 'foundations-components/transitional/components/View';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { useGetSummaryAnalytics } from '../../hooks/useGetSummaryAnalytics';
import { isUngatedToCHIRPEndpoints } from '../../utils/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditWarningModal = ({
  documentId,
  type,
  owner: ownerREST,
  handleConfirm,
  handleReject,
  showIcon = true,
  ['data-test-id']: dataTestId
}) => {
  var _documentAnalyticsSum;
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const {
    data: documentAnalyticsSummary
  } = useGetSummaryAnalytics({
    documentId
  });
  const ownerCHIRP = (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum === void 0 ? void 0 : _documentAnalyticsSum.user) || null;
  const ownerName = isUngatedToChirp ? ownerCHIRP && formatName(ownerCHIRP) : ownerREST && formatName(ownerREST.toObject());
  return /*#__PURE__*/_jsx(ConfirmModal, {
    "data-test-id": dataTestId,
    message: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      children: [showIcon && /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(WarningIcon, {
          size: "400",
          color: "do-not-use-marigold"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${type}EditWarningModal.message`
      })]
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${type}EditWarningModal.description`,
      options: {
        name: ownerName
      }
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${type}EditWarningModal.confirmLabel`
    }),
    onConfirm: handleConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${type}EditWarningModal.rejectLabel`
    }),
    onReject: handleReject
  });
};
export default EditWarningModal;